export default "__VITE_ASSET__CJjNRIK5__"